import axios from "axios";
import { API_URL } from "../utils/global-config";

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response) {
    //   switch (error.response.status) {
    //     case 401:
    //       break;
    //     case 403:
    //       break;
    //     case 404:
    //       break;
    //     default:
    //       break;
    //   }
    // }
    return Promise.reject(error);
  }
);

export default axiosInstance;
